import { call, put, select } from 'redux-saga/effects';
import CaravansActions from '../redux/caravansRedux';
import { has } from '../services/helper';

const getCaravanSaga = function* getCaravan(api, action) {
    const locale = yield select(state => state.locale);
    const response = yield call(api.getCaravan, action.identifier, locale);
    const caravan = has(response, 'data') ? response.data : null;
    if (response.ok) {
        yield put(CaravansActions.getCaravanSuccess(caravan));
    } else {
        yield put(CaravansActions.getCaravanFailure());
    }
};

const listCaravansSaga = function* listCaravans(api) {
    const locale = yield select(state => state.locale);
    const response = yield call(api.listCaravans, locale);

    if (response.ok) {
        const caravans = has(response, 'data') ? response.data : null;
        yield put(CaravansActions.listCaravansSuccess(caravans));
    } else {
        yield put(CaravansActions.listCaravansFailure());
    }
};

export {
    listCaravansSaga,
    getCaravanSaga,
};
